export default __webpack_public_path__ + "bc37c812c6146eab3c1bb169ab78500b.pdf";